import createIcon from '../../createIcon';

/**
 * @component @name MenuBook
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgNEMxOS44OSAzLjY1IDE4LjY3IDMuNSAxNy41IDMuNUMxNS41NSAzLjUgMTMuNDUgMy45IDEyIDVDMTAuNTUgMy45IDguNDUgMy41IDYuNSAzLjVDNC41NSAzLjUgMi40NSAzLjkgMSA1VjE5LjY1QzEgMTkuOSAxLjI1IDIwLjE1IDEuNSAyMC4xNUMxLjYgMjAuMTUgMS42NSAyMC4xIDEuNzUgMjAuMUMzLjEgMTkuNDUgNS4wNSAxOSA2LjUgMTlDOC40NSAxOSAxMC41NSAxOS40IDEyIDIwLjVDMTMuMzUgMTkuNjUgMTUuOCAxOSAxNy41IDE5QzE5LjE1IDE5IDIwLjg1IDE5LjMgMjIuMjUgMjAuMDVDMjIuMzUgMjAuMSAyMi40IDIwLjEgMjIuNSAyMC4xQzIyLjc1IDIwLjEgMjMgMTkuODUgMjMgMTkuNlY1QzIyLjQgNC41NSAyMS43NSA0LjI1IDIxIDRaTTIxIDE3LjVDMTkuOSAxNy4xNSAxOC43IDE3IDE3LjUgMTdDMTUuOCAxNyAxMy4zNSAxNy42NSAxMiAxOC41VjdDMTMuMzUgNi4xNSAxNS44IDUuNSAxNy41IDUuNUMxOC43IDUuNSAxOS45IDUuNjUgMjEgNlYxNy41WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE3LjUgOS41QzE4LjM4IDkuNSAxOS4yMyA5LjU5IDIwIDkuNzZWOC4yNEMxOS4yMSA4LjA5IDE4LjM2IDggMTcuNSA4QzE1LjggOCAxNC4yNiA4LjI5IDEzIDguODNWMTAuNDlDMTQuMTMgOS44NSAxNS43IDkuNSAxNy41IDkuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMyAxMS40OVYxMy4xNUMxNC4xMyAxMi41MSAxNS43IDEyLjE2IDE3LjUgMTIuMTZDMTguMzggMTIuMTYgMTkuMjMgMTIuMjUgMjAgMTIuNDJWMTAuOUMxOS4yMSAxMC43NSAxOC4zNiAxMC42NiAxNy41IDEwLjY2QzE1LjggMTAuNjYgMTQuMjYgMTAuOTYgMTMgMTEuNDlaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTcuNSAxMy4zM0MxNS44IDEzLjMzIDE0LjI2IDEzLjYyIDEzIDE0LjE2VjE1LjgyQzE0LjEzIDE1LjE4IDE1LjcgMTQuODMgMTcuNSAxNC44M0MxOC4zOCAxNC44MyAxOS4yMyAxNC45MiAyMCAxNS4wOVYxMy41N0MxOS4yMSAxMy40MSAxOC4zNiAxMy4zMyAxNy41IDEzLjMzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MenuBook = createIcon('MenuBook', [
  [
    'path',
    {
      d: 'M21 4C19.89 3.65 18.67 3.5 17.5 3.5C15.55 3.5 13.45 3.9 12 5C10.55 3.9 8.45 3.5 6.5 3.5C4.55 3.5 2.45 3.9 1 5V19.65C1 19.9 1.25 20.15 1.5 20.15C1.6 20.15 1.65 20.1 1.75 20.1C3.1 19.45 5.05 19 6.5 19C8.45 19 10.55 19.4 12 20.5C13.35 19.65 15.8 19 17.5 19C19.15 19 20.85 19.3 22.25 20.05C22.35 20.1 22.4 20.1 22.5 20.1C22.75 20.1 23 19.85 23 19.6V5C22.4 4.55 21.75 4.25 21 4ZM21 17.5C19.9 17.15 18.7 17 17.5 17C15.8 17 13.35 17.65 12 18.5V7C13.35 6.15 15.8 5.5 17.5 5.5C18.7 5.5 19.9 5.65 21 6V17.5Z',
      key: 'h0qwoz',
    },
  ],
  [
    'path',
    {
      d: 'M17.5 9.5C18.38 9.5 19.23 9.59 20 9.76V8.24C19.21 8.09 18.36 8 17.5 8C15.8 8 14.26 8.29 13 8.83V10.49C14.13 9.85 15.7 9.5 17.5 9.5Z',
      key: '1c51t4',
    },
  ],
  [
    'path',
    {
      d: 'M13 11.49V13.15C14.13 12.51 15.7 12.16 17.5 12.16C18.38 12.16 19.23 12.25 20 12.42V10.9C19.21 10.75 18.36 10.66 17.5 10.66C15.8 10.66 14.26 10.96 13 11.49Z',
      key: '1v7q4t',
    },
  ],
  [
    'path',
    {
      d: 'M17.5 13.33C15.8 13.33 14.26 13.62 13 14.16V15.82C14.13 15.18 15.7 14.83 17.5 14.83C18.38 14.83 19.23 14.92 20 15.09V13.57C19.21 13.41 18.36 13.33 17.5 13.33Z',
      key: '1ga5iv',
    },
  ],
]);

export default MenuBook;
